export enum CUSTOM_GROUPS_FETCH_STATE {
	LOADING,
	SUCCESS,
	ERROR,
}

export type QueryDirectionType = 'asc' | 'desc';
export type SortDirection = QueryDirectionType;

export interface CustomGroupQueryOptions {
	search?: string;
	page?: number;
	limit?: number;
	sortFields?: string | string[];
	sortDirections?: 'asc' | 'desc' | ('asc' | 'desc')[];
}

export interface CustomGroupResponse {
	_id: string;
	customGroupID: string;
	createdAt: Date | number;
	createdBy: string;
	createdByName: string;
	description: string;
	customGroupName: string;
	organizationID: string;
	status: string;
	updatedAt: Date | number;
	updatedBy: string;
	updatedByName: string;
	totalUsers: number;
	totalUserGroups: number;
	populated: CustomGroupPopulated;
}

export interface PopulatedUser {
	userID: string;
	lmsRole: string;
	displayName: string;
}

export interface PopulatedUserGroup {
	userGroupID: string;
	userGroupName: string;
	totalUsers: number;
}

export interface CustomGroupPopulated {
	users: PopulatedUser[];
	userGroups: PopulatedUserGroup[];
}

export interface CustomGroupPaginatedResponse {
	docs: CustomGroupResponse[];
	totalDocs?: number;
	limit?: number;
	page?: number;
	totalPages?: number;
}

export interface CustomGroupListState {
	page: number;
	limit: number;
	search: string;
	// NOTE: 'totalUsers' removed from sort options - custom groups no longer manage individual users
	sortBy: 'customGroupName' | 'createdAt' | 'createdByName' | 'totalUserGroups'; // | 'totalUsers' - removed
	sortDirection: SortDirection;
	fetchState: CUSTOM_GROUPS_FETCH_STATE;
	customGroupList: CustomGroupResponse[];
	totalCustomGroups: number;
	isLoading: boolean;
	isSuccess: boolean;
	error?: string | null;
}

export interface GetCustomGroupListRequestInterface {
	page?: number;
	limit?: number;
	search?: string;
}
